import React from "react";

const VercelLogo = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
            <path d="M64.002 8.576 128 119.424H0Zm0 0" />
        </svg>
    );
};

export default VercelLogo;
